export default __webpack_public_path__ + "static/media/features-section-3.448ed064.png";